import MainTabs from "components/UI/organisms/MainTabs";
import { COMPONENT_TYPES } from "helpers/utils/constants";
import React, { useEffect, useState } from "react";
import JobsListing from "./listings/JobsListing";
import useFilters, { FILTER_TYPES } from "helpers/hooks/useFilters";
import { useSearchParams } from "react-router-dom";
import useJobNetwork from "store/job-network";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";
import EmptyText from "components/UI/atoms/EmptyText";
import useListingHeader from "helpers/hooks/useListingHeader";
import ListingPageHeader from "components/UI/organisms/ListingPageHeader";
import BrowseWrapper from "components/UI/organisms/BrowseWrapper";
import { hasFiltersApplied } from "helpers/utils/utilities";

const BrowseJobNetwork = ({}) => {
  const [tab, setTab] = useState(0);
  const [browseMode, setBrowseMode] = useState(0);
  const { gridType, setGridType, search, setSearch, sort, setSort } =
    useListingHeader();
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  let [searchParams, setSearchParams] = useSearchParams();
  const searchTab = searchParams.get("tab");
  const { fetchJobs, fetchMyJobs, applyJob } = useJobNetwork();
  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [myJobs, setMyJobs] = useState([]);
  const { t } = useLocalizedTranslation("common");
  const { selected } = useFilters();

  useEffect(() => {
    if (tab !== 0) return;
    handleFetchJobs();
  }, [search, tab, browseMode, selected, page, sort]);

  useEffect(() => {
    if (tab !== 1) return;
    handleFetchMyJobs();
  }, [search, browseMode, tab, selected, page]);

  const handleFetchJobs = async () => {
    setLoading(true);
    const filters = { search, ...selected, page, sort_by: sort };
    const res = await fetchJobs(filters, true);
    setJobs(res?.list || []);
    if (page > res?.total_pages) setPage(res?.total_pages);
    setPages(res?.total_pages || 0);
    if (tab === 0) setTotalCount(res?.total_count);
    setLoading(false);
  };

  const handleFetchMyJobs = async () => {
    setLoading(true);
    const filters = { search, ...selected, page };
    const res = await fetchMyJobs(filters);
    setMyJobs(res?.list || []);
    if (page > res?.total_pages) setPage(res?.total_pages);
    setPages(res?.total_pages || 0);
    if (tab === 1) setTotalCount(res?.total_count);
    setLoading(false);
  };

  useEffect(() => {
    if (searchTab) {
      setTab(+searchTab);
    }
  }, [searchTab]);

  const handleChangeTab = (i) => {
    searchParams.set("tab", i);
    searchParams.set("browseMode", 0);
    setSearchParams(searchParams);
    setTab(i);
    if (page !== 1) setPage(1);
  };

  const handleApplyJob = async (uuid) => {
    const res = await applyJob(uuid);
    if (res?.data?.success)
      setJobs((prev) =>
        prev.map((d) => ({
          ...d,
          application_applied:
            d?.uuid === uuid ? "yes" : d?.application_applied,
          application_status:
            d?.uuid === uuid ? "pending" : d?.application_status,
        }))
      );
  };

  return (
    <BrowseWrapper
      browseMode={browseMode}
      setBrowseMode={setBrowseMode}
      component={COMPONENT_TYPES.JOB_NETWORK}
      pageTitle="Job Network"
      hidePlan
      filters={[
        FILTER_TYPES.DATE_POSTED,
        FILTER_TYPES.WORK_MODE,
        FILTER_TYPES.EXPERIENCE_LEVEL,
        FILTER_TYPES.JOB_TYPE,
      ]}
      hideSearchSort
      noAction
    >
      <MainTabs
        tabs={["Job Board", "Application Status"]}
        current={tab}
        setCurrent={handleChangeTab}
      />
      <ListingPageHeader
        gridType={gridType}
        setGridType={setGridType}
        search={search}
        setSearch={setSearch}
        noCard
        noSort={tab === 1}
        classes="my-3"
        hideSearchButton
        searchInputHeight="40px"
        leftMd={tab === 0 ? 7 : null}
        setSort={setSort}
        sort={sort}
        sortOptions={[
          {
            value: "Recent",
            key: "creation_date",
          },
          {
            value: "Relevance",
            key: "relevance",
          },
        ]}
      />
      {totalCount ? (
        <h4 className="mt-4">
          {totalCount} {t("Results", "common")}
        </h4>
      ) : null}
      <JobsListing
        jobs={tab === 0 ? jobs : myJobs}
        loading={loading}
        page={page}
        pageCount={pages}
        setPage={setPage}
        gridType={gridType}
        onApply={handleApplyJob}
        myJob={tab === 1}
        emptyView={
          <EmptyText>
            {hasFiltersApplied(selected) || Boolean(search)
              ? t("No Results Found!", "common")
              : tab === 0
              ? t("There are no jobs at this moment. Please check back later.")
              : t(
                  "Jobs you have applied to will show up here. Apply to your first job today!"
                )}
          </EmptyText>
        }
      />
    </BrowseWrapper>
  );
};

export default BrowseJobNetwork;
